<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [subtitle]="subtitle"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canCreateNewExcel]="true"
    [canImportExcel]="true"
    [canExportExcel]="true"
    (onClearFilterEvent)="onClearFilters()"
    (onNewEvent)="onNew()"
    (onImportEvent)="onImport()"
    (onExportAsExcelEvent)="exportAsExcel()"
    >
  </app-header-form>
</div>

<hr>

<div class="container-fluid">
    <app-table
      [data]="dataItems"
      [tableActions]="tableActions"
      [tableIndications]="tableIndications"
      [columnsDefinition]="columnsDefinition"
      [onChangeStatus] = "onChangeStatus"
      [configKey]="configKey"
      [exportFileName]="exportFileName"
      [showClearFilterButton]="true"
      [onFiltersCleared]="onFiltersCleared"
      [onExportExcelCaller]="onExportExcelCaller"
      ngDefaultControl>
    </app-table>
</div>
